import { Empty } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

interface NoSearchDataFoundInterface {
    imageStyle?: React.CSSProperties
    hasMessage?: boolean

    icon?: string
    title?: string
    message?: string

    children?: React.ReactNode
}

export const NoSearchDataFound = ({
    imageStyle,
    hasMessage = true,
    icon = "./icons/no_data_found.svg",
    title = "info:no_search_data_found.title",
    message = "info:no_search_data_found.message",
    children,
}: NoSearchDataFoundInterface) => {
    const { t } = useTranslation()
    return (
        <div>
            <Empty
                image={icon}
                imageStyle={{
                    height: 150,
                    marginRight: "auto",
                    marginLeft: "auto",
                    marginTop: "15%",
                    marginBottom: "40px",
                    display: "inline-block",
                    ...imageStyle,
                }}
                description={<span className="text-lg font-bold mt-2 mb-0">{t(title)}</span>}
            >
                {hasMessage ? <p>{t(message)}</p> : <></>}
                {children}
            </Empty>
        </div>
    )
}
